function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import wrapComponent from "../../core/wrapComponent";
import * as R from 'unitx/ramda';

const ItemRender = props => {
  var _R$path;

  const {
    parentItem,
    level,
    accessor,
    path,
    item,
    defaultRenderChildren,
    renderChildren,
    renderItem,
    extraData
  } = props;
  const childLevel = level + 1;
  const childPath = [...path, item.id];
  const itemDefaultRenderChildren = React.useCallback(childProps => defaultRenderChildren(_objectSpread({
    level: childLevel,
    path: childPath,
    parentItem: item,
    defaultRenderChildren: itemDefaultRenderChildren,
    accessor
  }, childProps)), [accessor, extraData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderItem({
    item,
    level,
    path: childPath,
    parentItem,
    accessor,
    defaultRenderChildren: itemDefaultRenderChildren,
    children: renderChildren ? renderChildren({
      level: childLevel,
      path: childPath,
      parentItem: item,
      defaultRenderChildren: itemDefaultRenderChildren,
      data: (_R$path = R.path(accessor)(item)) !== null && _R$path !== void 0 ? _R$path : [],
      accessor
    }) : // @ts-ignore
    itemDefaultRenderChildren(),
    extraData,
    renderItem,
    renderChildren
  }));
};

export default wrapComponent(ItemRender, {
  isEqual: R.equalsExclude(R.isFunction)
});